import React, { Component } from "react";
import Flippy, { FrontSide, BackSide } from 'react-flippy';
import icoEquivalencia from '../../assets/images/equivalencia.png';
import icoNuevoIngreso from '../../assets/images/nuevoingreso.png';
import icoReingreso from '../../assets/images/reingreso.png';
import icoProcesoGraduacion from '../../assets/images/pgraduación.png';
import icoMaestria from '../../assets/images/maestria.png';
import './CardsTramites.css';
import { MDBRow, MDBCol } from "mdbreact";
import { WOW } from 'wowjs'


class Cards extends Component {
    componentDidMount() {
        const wow = new WOW({
            offset: 100,
            mobile: false,
            live: true
        })

        wow.init();
    }

    render() {
        return (
            <React.Fragment>
                <div className="spacer-50 mb-4"></div>
                <div className="container-fluid">
                    <MDBRow className="mb-4">
                        <MDBCol>
                            <h1 className="tituloCondiciones2 futuraBold wow zoomInDown fz-r">
                                TRÁMITES EN LÍNEA
                            </h1>
                        </MDBCol>
                    </MDBRow>
                    <MDBRow className="wow fadeInLeft justify-content-center">

                        <MDBCol className="col p-1 mb-4 mt-4">
                            <Flippy
                                flipOnHover={true}
                                flipDirection="vertical"
                                flipOnClick={true}
                                ref={(r) => this.flippy = r}
                                className="flip"
                                style={{ height: '240px', maxWidth: '280px', margin: '0 auto' }}
                            >
                                <FrontSide className="cuadro">
                                    <img src={icoNuevoIngreso} className="iconoCard22" alt="Nuevo ingreso" />
                                    <div className="futuraBold tituloCard">
                                        NUEVO INGRESO
                                        </div>
                                </FrontSide>

                                <BackSide
                                    className="backSide">
                                    <div className="textoBackSide">
                                        <p className="textoCard">
                                            Expresamos nuestros agradecimientos por depositar tu confianza en la UFG, inicia tu formación universitaria en una de nuestras carreras y/o modalidades.
                                            </p>
                                    </div>
                                </BackSide>
                            </Flippy>
                        </MDBCol>

                        <MDBCol className="col p-1 mb-4 mt-4">
                            <Flippy
                                flipOnHover={true}
                                flipDirection="vertical"
                                flipOnClick={true}
                                ref={(r) => this.flippy = r}
                                style={{ height: '240px', maxWidth: '280px', margin: '0 auto' }}
                            >
                                <FrontSide className="cuadrot">
                                    <img src={icoEquivalencia} className="iconoCard22" alt="Ingreso por equivalencia" />
                                    <div className="futuraBold tituloCard">
                                        INGRESO POR EQUIVALENCIA
                                    </div>
                                </FrontSide>
                                <BackSide
                                    className="backSide">
                                    <div className="textoBackSide">
                                        <p className="textoCard">
                                            Continúa tus estudios universitarios previos realizados en otras instituciones de educación superior, ya sea nacionales o en el extranjero, legalmente autorizadas.
                                            </p>
                                    </div>
                                </BackSide>
                            </Flippy>
                        </MDBCol>

                        <MDBCol className="col p-1 mb-4 mt-4">
                            <Flippy
                                flipOnHover={true}
                                flipDirection="vertical"
                                flipOnClick={true}
                                ref={(r) => this.flippy = r}
                                style={{ height: '240px', maxWidth: '280px', margin: '0 auto' }}
                            >
                                <FrontSide className="cuadro">
                                    <img src={icoReingreso} className="iconoCard22" alt="Reingreso" />
                                    <div className="futuraBold tituloCard">
                                        REINGRESO
                                    </div>
                                </FrontSide>
                                <BackSide
                                    className="backSide">
                                    <div className="textoBackSide">
                                        <p className="textoCard">
                                            Te felicitamos por tener el deseo de retomar tus estudios universitarios, recuerda que estás cerca de convertirte en un profesional de éxito.
                                            </p>
                                    </div>
                                </BackSide>
                            </Flippy>
                        </MDBCol>

                        <MDBCol className="col p-1 mb-4 mt-4">
                            <Flippy
                                flipOnHover={true}
                                flipDirection="vertical"
                                flipOnClick={true}
                                ref={(r) => this.flippy = r}
                                style={{ height: '240px', maxWidth: '280px', margin: '0 auto' }}
                            >
                                <FrontSide className="cuadrot">
                                    <img src={icoProcesoGraduacion} className="iconoCard22 imgCenter" alt="Ingreso por equivalencia" />
                                    <div className="futuraBold tituloCard">
                                        GRADUACIÓN DE PREGRADO
                                    </div>
                                </FrontSide>
                                <BackSide
                                    className="backSide">
                                    <div className="textoBackSide">
                                        <p className="textoCard">
                                            ¡El éxito es tuyo! Culmina tu proceso de graduación para ser un profesional UFG.
                                        </p>
                                    </div>
                                </BackSide>
                            </Flippy>
                        </MDBCol>

                        <MDBCol className="col p-1 mb-4 mt-4">
                            <Flippy
                                flipOnHover={true}
                                flipDirection="vertical"
                                flipOnClick={true}
                                ref={(r) => this.flippy = r}
                                style={{ height: '240px', maxWidth: '280px', margin: '0 auto' }}
                            >
                                <FrontSide className="cuadro">
                                    <img src={icoMaestria} className="iconoCard22 imgCenter" alt="Reingreso" />
                                    <div className="futuraBold tituloCard">
                                        GRADUACIÓN DE MAESTRÍA
                                    </div>
                                </FrontSide>
                                <BackSide
                                    className="backSide">
                                    <div className="textoBackSide">
                                        <p className="textoCard">
                                            Te felicitamos por llegar al siguiente nivel en tu formación profesional con una Maestría UFG.
                                        </p>
                                    </div>
                                </BackSide>
                            </Flippy>
                        </MDBCol>


                    </MDBRow>
                </div>
            </React.Fragment>
        );
    }
}
export default Cards;